'use client';
import { useGeneralStore } from '@/providers/general-store-provider';
import Accordion from './accordion.component';

import { TYPE_BIKE } from '@/helpers/constants';
import { useMemo } from 'react';
import './accordion.scss';

export default function AccordionList() {
    const { vehicleType } = useGeneralStore();

    const FAQ = [
        {
            title: <h3 data-testid="faq-question-01" id="faq-question-01">O que é a Tabela FIPE?</h3>,
            content: (
                <div data-testid="faq-content-01" id="faq-content-01">
                    <p data-testid="faq-content-01-p1" id="faq-content-01-p1">
                        A <b>Tabela FIPE</b>, criada pela Fundação Instituto de Pesquisas Econômicas (FIPE), é
                        reconhecida por divulgar preços médios de mercado de carros, motos e caminhões, novos, seminovos
                        e usados, em todo o Brasil, para servir de parâmetro em negociações e avaliações dos automóveis.
                    </p>
                    <p data-testid="faq-content-01-p2" id="faq-content-01-p2">
                        No entanto, para transações, além das estimativas da tabela, leva-se em consideração outros
                        fatores como conservação, opcionais, revisões concluídas, entre outras especificidades que podem
                        influenciar uma oferta.
                    </p>
                </div>
            ),
        },
        {
            title: <h3 data-testid="faq-question-02" id="faq-question-02">Quando surgiu a FIPE?</h3>,
            content: (
                <div data-testid="faq-content-02" id="faq-content-02">
                    <p data-testid="faq-content-02-p1" id="faq-content-02-p1">
                        O órgão surgiu em 1973, à época, criado para auxiliar alguns cursos da Universidade de São Paulo
                        (USP). Entre os vários serviços prestados, o mais conhecido deles, sem dúvida, é o Preço Médio
                        de Veículos, também conhecido como Tabela FIPE.
                    </p>
                </div>
            ),
        },
        {
            title: <h3 data-testid="faq-question-03" id="faq-question-03">Como a Tabela FIPE funciona?</h3>,
            content: (
                <div data-testid="faq-content-03" id="faq-content-03">
                    <p data-testid="faq-content-03-p1" id="faq-content-03-p1">
                        Os valores médios divulgados são atualizados mensalmente. Para quem interesse em saber{' '}
                        <b>como é calculado a Tabela FIPE</b>, vamos explicar.
                    </p>
                    <p data-testid="faq-content-03-p2" id="faq-content-03-p2">
                        O índice é baseado na coleta de preços de automóveis em todo o território nacional. Para chegar
                        na média, é realizado um filtro que exclui os preços muito discrepantes (para baixo ou para
                        cima).
                    </p>
                    <p data-testid="faq-content-03-p3" id="faq-content-03-p3">
                        Com os valores que restaram, aqueles que são próximos, é criado uma média de preço, divulgada
                        todo mês na tabela. Para realizar uma pesquisa, os usuários podem filtrar por ano-modelo,
                        motorização e versão do veículo de interesse.
                    </p>
                </div>
            ),
        },
        {
            title: <h3 data-testid="faq-question-04" id="faq-question-04">Quando usar a Tabela FIPE?</h3>,
            content: (
                <div data-testid="faq-content-04" id="faq-content-04">
                    <p data-testid="faq-content-04-p1" id="faq-content-04-p1">
                        Além de te oferecer a possibilidade de consultar os preços dos mais diversos veículos para
                        comprar um modelo, a Tabela FIPE é ideal para quem está pensando em vender o seu próprio carro
                        ou moto.
                    </p>
                    <p data-testid="faq-content-04-p2" id="faq-content-04-p2">
                        Consultando a tabela você consegue traçar um ponto de partida para a avaliação do seu automóvel
                        no mercado. Mas é importante lembrar: a FIPE é uma referência e, ao definir um valor, é
                        importante levar como base outros fatores como a quilometragem, os itens de série, a quantidade
                        de revisões realizadas, entre outras especificidades.
                    </p>
                    <p data-testid="faq-content-04-p3" id="faq-content-04-p3">
                        Mas suas utilidades não se limitam apenas aos compradores ou vendedores de veículos. Os valores
                        divulgados na Tabela FIPE são usados de parâmetro para o cálculo dos valores do IPVA e à
                        indenização do seguro dos automóveis. Ou seja, ela também presta serviços ao governo e
                        instituições privadas.
                    </p>
                </div>
            ),
        },
        {
            title: <h3 data-testid="faq-question-05" id="faq-question-05">O que é a Tabela Webmotors?</h3>,
            content: (
                <div data-testid="faq-content-05" id="faq-content-05">
                    <p data-testid="faq-content-05-p1" id="faq-content-05-p1">
                        Na Webmotors a tabela FIPE é comparada com as informações da própria plataforma, isso é, uma
                        comparação do valor de tabela com os preços praticados no mercado real, levando em conta as
                        transações feitas na própria plataforma da Webmotors, chamamos de Tabela Webmotors. Com isso, a
                        principal vantagem é que você pode ter uma análise mais precisa e real de valores praticados
                        pelo mercado.
                    </p>
                </div>
            ),
        },
        {
            title: <h3 data-testid="faq-question-06" id="faq-question-06">Como consultar a Tabela FIPE?</h3>,
            content: (
                <div data-testid="faq-content-06" id="faq-content-06">
                    <p data-testid="faq-content-06-p1" id="faq-content-06-p1">
                        Para facilitar a sua busca, busque o carro ou moto de interesse na{' '}
                        <b>Tabela FIPE e Tabela Webmotors</b> e faça todas as pesquisas necessárias. E lembre-se, para
                        aqueles interessados em comprar ou vender, saber o valor médio real negociado do modelo de
                        interesse, é ideal para se ter como referência e conseguir bons resultados de compra e venda.
                    </p>
                </div>
            ),
        },
    ];

    const FAQBike = [
        {
            title: <h3 data-testid="faq-question-07" id="faq-question-07">Para que serve a Tabela Fipe?</h3>,
            content: (
                <div data-testid="faq-content-07" id="faq-content-07">
                    <p data-testid="faq-content-07-p1" id="faq-content-07-p1">
                        A Tabela Fipe apresenta os preços médios de venda à vista de carros e motos praticados para o
                        consumidor final, pessoa física, no mercado brasileiro. Ela serve como uma referência para
                        negociações e avaliações, oferecendo um parâmetro base para quem vai comprar ou vender.
                    </p>
                </div>
            ),
        },
        {
            title: <h3 data-testid="faq-question-08" id="faq-question-08">Quando usar a Tabela Fipe Motos?</h3>,
            content: (
                <div data-testid="faq-content-08" id="faq-content-08">
                    <p data-testid="faq-content-08-p1" id="faq-content-08-p1">
                        A Tabela Fipe Motos pode ser usada quando você quiser consultar preços de motocicletas, seja
                        para compra ou venda. Além disso, ela também pode ser utilizada, por exemplo, para calcular o
                        Imposto sobre Propriedade de Veículos Automotores (IPVA).
                    </p>
                </div>
            ),
        },
        {
            title: <h3 data-testid="faq-question-09" id="faq-question-09">Como consultar Tabela Fipe de Moto?</h3>,
            content: (
                <div data-testid="faq-content-09" id="faq-content-09">
                    <p data-testid="faq-content-09-p1" id="faq-content-09-p1">
                        É muito fácil fazer a consulta e descobrir o valor da Tabela Fipe para um modelo de moto. Basta
                        selecionar as seguintes informações do modelo que quiser avaliar:
                    </p>
                    <div
                        className="accordion-content-list"
                        data-testid="faq-content-09-list"
                        id="faq-content-09-list"
                    >
                        <p data-testid="faq-content-09-list-item-1" id="faq-content-09-list-item-1">1. Marca do modelo.</p>
                        <p data-testid="faq-content-09-list-item-2" id="faq-content-09-list-item-2">2. Nome do modelo.</p>
                        <p data-testid="faq-content-09-list-item-3" id="faq-content-09-list-item-3">3. Ano do modelo.</p>
                        <p data-testid="faq-content-09-list-item-4" id="faq-content-09-list-item-4">4. Estado para o qual pretende avaliar a compra ou venda.</p>
                        <p data-testid="faq-content-09-list-item-5" id="faq-content-09-list-item-5">5. Depois é só clicar em "Consultar Valor".</p>
                    </div>
                </div>
            ),
        },
        {
            title: <h3 data-testid="faq-question-10" id="faq-question-10">Qual ano considerar na Tabela Fipe?</h3>,
            content: (
                <div data-testid="faq-content-10" id="faq-content-10">
                    <p data-testid="faq-content-10-p1" id="faq-content-10-p1">
                        A Tabela Fipe é atualizada todos os meses e considera a marca, o modelo e o ano do veículo,
                        sendo que o ano levado em conta é sempre o do modelo, e não o de fabricação. Os valores são
                        expressos em reais, com base no mês e ano de referência, e não incluem veículos destinados a uso
                        profissional ou especial.
                    </p>
                </div>
            ),
        },
        {
            title: <h3 data-testid="faq-question-11" id="faq-question-11">Tabela Webmotors: o que é?</h3>,
            content: (
                <div data-testid="faq-content-11" id="faq-content-11">
                    <p data-testid="faq-content-11-p1" id="faq-content-11-p1">
                        É a nossa referência de preços para modelos de carros e motos. Na Webmotors, comparamos o valor
                        de tabela Fipe com os preços reais praticados no mercado, levando em consideração as transações
                        realizadas dentro da nossa plataforma. Essa é a Tabela Webmotors. Dessa forma, você tem acesso a
                        uma análise mais precisa e fiel aos valores praticados no mercado.
                    </p>
                </div>
            ),
        },
    ];

    const faq = useMemo(() => (vehicleType == TYPE_BIKE ? FAQBike : FAQ), [vehicleType]);

    const listFAQ = useMemo(
        () => faq?.map((faq, index) => <Accordion key={index} title={faq.title} content={faq.content} />),
        [faq],
    );

    return listFAQ;
}
